export const mockListings = [
  {
    id: "listing-1",
    title: "SaaS para gestión de gimnasios",
    category: "SaaS",
    description:
      "Plataforma completa para gestionar suscripciones, reservas, entrenadores y pagos en centros deportivos.",
    askingPrice: "480.000€",
    ttmRevenue: "320.000€",
    ttmProfit: "95.000€",
    lastMonthRevenue: "29.000€",
    lastMonthProfit: "8.700€",
    founded: "Enero 2021",
    country: "España",
    teamSize: "3-5",
    businessModel: ["Suscripción", "B2B"],
    services: "Software para automatizar la gestión de gimnasios, integraciones con TPV y apps móviles.",
    techStack: ["React", "Node.js", "PostgreSQL", "AWS"],
    highlights: [
      "Base sólida de clientes en España y LATAM",
      "Integraciones con Stripe, Google Calendar",
      "Panel de control intuitivo y escalable",
    ],
    competitors: ["Virtuagym", "TraininGym"],
    growthOpportunities: [
      "Expansión a mercados anglosajones",
      "Campañas con influencers fitness",
      "Integración con dispositivos IoT",
    ],
    assets: ["Código fuente", "Dominio", "Clientes activos", "Infraestructura en AWS", "App iOS y Android"],
    reasoning: ["Cambio de sector", "Falta de tiempo"],
    financing: "Bootstrapped",
    createdBy: "admin",
  },
  {
    id: "listing-2",
    title: "Marketplace para productos ecológicos",
    category: "Marketplace",
    description:
      "Marketplace con fuerte comunidad y crecimiento en la venta directa de productos sostenibles y bio.",
    askingPrice: "$650k",
    ttmRevenue: "$410k",
    ttmProfit: "$120k",
    lastMonthRevenue: "$38k",
    lastMonthProfit: "$9k",
    founded: "Julio 2020",
    country: "México",
    teamSize: "6-10",
    businessModel: ["Comisión", "Marketplace"],
    services: "Plataforma de intermediación entre productores ecológicos y consumidores finales.",
    techStack: ["Vue.js", "Firebase", "Algolia"],
    highlights: [
      "Amplia comunidad fiel",
      "SEO orgánico muy bien posicionado",
      "Alianzas con más de 120 productores",
    ],
    competitors: ["Ecoverde", "BioMarket"],
    growthOpportunities: [
      "Inversión en campañas en redes",
      "Expansión a nuevos países",
      "Mejora del onboarding de productores",
    ],
    assets: ["Marketplace web", "Base de datos de productores", "Blog SEO", "Canal de Telegram activo"],
    reasoning: ["Foco en otro proyecto", "Búsqueda de socio inversor"],
    financing: "Inversión externa",
    createdBy: "admin",
  }, 
  {
    id: "listing-3",
    title: "Plataforma de e-learning para profesionales de salud",
    category: "EdTech",
    description:
      "Portal de formación continua con cursos acreditados para médicos, enfermeros y fisioterapeutas. Integración con colegios profesionales.",
    askingPrice: "$720k",
    ttmRevenue: "$390k",
    ttmProfit: "$150k",
    lastMonthRevenue: "$35k",
    lastMonthProfit: "$12k",
    founded: "Marzo 2019",
    country: "España",
    teamSize: "5-7",
    businessModel: ["Suscripción", "Pago único"],
    services: "Catálogo de cursos online, exámenes, certificados y seguimiento del progreso.",
    techStack: ["Next.js", "Firebase", "Stripe", "Typeform"],
    highlights: [
      "Certificación oficial y homologación en 3 países",
      "Más de 12.000 alumnos registrados",
      "Automatización de exámenes y diplomas",
    ],
    competitors: ["SalusOne", "Formación Alcalá"],
    growthOpportunities: [
      "Traducir contenido a inglés y portugués",
      "Acuerdos con universidades y hospitales",
      "Venta de contenido a terceros",
    ],
    assets: ["Portal web", "Contenido propietario", "Base de usuarios", "Certificados y convenios"],
    reasoning: ["Búsqueda de liquidez", "Reorientación profesional"],
    financing: "Bootstrapped",
    createdBy: "admin",
  },
  {
    id: "listing-4",
    title: "App de finanzas personales para jóvenes",
    category: "Fintech",
    description:
      "App intuitiva para ayudar a estudiantes y jóvenes profesionales a gestionar gastos, ahorrar y aprender educación financiera.",
    askingPrice: "$550k",
    ttmRevenue: "$270k",
    ttmProfit: "$85k",
    lastMonthRevenue: "$22k",
    lastMonthProfit: "$6.3k",
    founded: "Agosto 2021",
    country: "Colombia",
    teamSize: "3",
    businessModel: ["Freemium", "Publicidad", "Suscripción Pro"],
    services: "Gestor de presupuestos, alertas de gastos, consejos automatizados y retos de ahorro.",
    techStack: ["Flutter", "Firebase", "Plaid", "Stripe"],
    highlights: [
      "Más de 50.000 descargas",
      "Top 10 apps de finanzas en LATAM",
      "Integración bancaria automatizada",
    ],
    competitors: ["Fintonic", "Bnext", "Goin"],
    growthOpportunities: [
      "Campañas en universidades",
      "Nuevos retos gamificados",
      "Partnerships con bancos juveniles",
    ],
    assets: ["App Android/iOS", "Usuarios activos", "Branding", "Infraestructura Firebase"],
    reasoning: ["Falta de capital para escalar", "Interés en vender y pasar a otro proyecto"],
    financing: "Inversión externa",
    createdBy: "admin",
  },
  {
    id: "listing-5",
    title: "Agencia de marketing especializada en eCommerce",
    category: "Agencia",
    description:
      "Agencia con más de 20 tiendas online activas bajo gestión. Experta en performance marketing, CRO y email automation.",
    askingPrice: "$420k",
    ttmRevenue: "$310k",
    ttmProfit: "$110k",
    lastMonthRevenue: "$26k",
    lastMonthProfit: "$9k",
    founded: "Febrero 2020",
    country: "Argentina",
    teamSize: "4",
    businessModel: ["Retainer mensual", "Proyectos a medida"],
    services: "Ads (Meta, Google), email marketing, estrategia y diseño UX/UI.",
    techStack: ["Webflow", "Klaviyo", "Meta Ads", "GA4"],
    highlights: [
      "Clientes en Argentina, Chile y México",
      "Retención promedio >12 meses",
      "Equipo senior 100% remoto",
    ],
    competitors: ["Kampal", "LatamDigital", "GrowFy"],
    growthOpportunities: [
      "Expandir equipo de ventas",
      "Servicios de SEO recurrente",
      "Cursos de formación propios",
    ],
    assets: ["Cartera de clientes", "Sitio web", "Automatizaciones de email", "Plantillas de campañas"],
    reasoning: ["Interés en enfocarse en otro rubro", "Buscar liquidez rápida"],
    financing: "Bootstrapped",
    createdBy: "admin",
  }
  
];
